export const defaultInputValidationPaneCancelButtonHoveredStyles = {};